import React, { Fragment, useState } from 'react';
//import history from '../../../';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Delete from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CloseIcon from '@material-ui/icons/Close';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import Modal from '../../../shared/components/Modal';
import ModalMat from '@material-ui/core/Modal';
import RepeatIcon from '@material-ui/icons/Repeat';
import { useEffect } from 'react';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import ImageIcon from '@material-ui/icons/Image';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import ExcelReportFees from '../../Fees/components/ExcelReportFees';
import ReportFeeExpensePDF from '../../Fees/components/ReportFeeExpensePDF';

const ReactTableActionsExpenses = ({ data, refresh, editExpenseFromTable }) => {

    const [isDelete, setIsdeleted] = useState(false);
    const [showImage, setShowImage] = useState(false);
    const imageShow = data.data.original.url_imagen;

    useEffect(() => {
        console.log("DATA", data)
    }, [])

    const onToggleToEditExpense = (expense) => {
        editExpenseFromTable(expense);
    }

    const onDelet = () => {
        setIsdeleted(false);
        let dataSend = { id_gasto: data.data.original.id_gasto };
        console.log(dataSend);
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'gastos/delete', {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            }).then(response => {
                console.log(response);
                refresh();
                return response.json();
            }).then(data => {
                resolve(true);
            }).catch((error) => {
                resolve(error);
            });
        })
    }

    const loadFeeInfo = async (infoExport, idFeeExpense) => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + `honorarios-efectuados/${idFeeExpense}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if(response.status != 500 && response.status != 403)
            {
                return response.json();
            }
            else
            {
                throw new Error('Ha ocurrido un error consultando el Honorario');
            }
        }).then(dataResponse => {
            let dataHonorario = dataResponse.honorario;
            dataHonorario.honorarios_profesional = dataHonorario.honorarios_profesional.honorariosMedicos;

            let clinicaData = JSON.parse(sessionStorage.getItem('clinica'));
            let localidadData = JSON.parse(sessionStorage.getItem('localidad'));

            clinicaData.nombre_ciudad = localidadData.ciudad;
            clinicaData.nombre_departamento = localidadData.dpto;

            switch(infoExport)
            {
                case "EXCEL":
                    ExcelReportFees.exportExcel([dataHonorario]);
                break;
                case "PDF":
                    ReportFeeExpensePDF(dataHonorario, clinicaData);
                break;
                default:
                    alert("Opción no Disponible");
                break;
            }
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    return (<Fragment>
        <td role="cell">
            <Tooltip title="Editar">
                <IconButton disabled={data.data.original.id_honorario_efectuado != null ? true : false} aria-label="edit" onClick={() => {
                    onToggleToEditExpense(data.data.original)
                }}>
                    <EditOutlinedIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title="Visualizar Recibo">
                <IconButton
                    aria-label="edit"
                    disabled={imageShow == undefined && imageShow == null ? true : false}
                    onClick={() => {
                        setShowImage(true);
                    }}>
                    <ImageIcon />
                </IconButton>
            </Tooltip>

            <Tooltip title="Eliminar Gasto">
                <IconButton disabled={data.data.original.id_honorario_efectuado != null ? true : false} aria-label="delete" onClick={() => {
                    setIsdeleted(true);
                }}>
                    <DeleteForeverIcon />
                </IconButton>
            </Tooltip>

            {
                data.data.original.id_honorario_efectuado != null ? <>
                    <Tooltip title="PDF Honorario">
                        <IconButton aria-label="delete" onClick={() => {
                            loadFeeInfo("PDF", data.data.original.id_honorario_efectuado);
                        }}>
                            <FontAwesomeIcon icon={faFilePdf} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Excel Honorario">
                        <IconButton aria-label="delete" onClick={() => {
                            loadFeeInfo("EXCEL", data.data.original.id_honorario_efectuado);
                        }}>
                            <FontAwesomeIcon icon={faFileExcel} />
                        </IconButton>
                    </Tooltip>
                </> : null
            }

            {isDelete ?
                <Modal
                    color={'warning'}
                    title={"Seguro"}
                    message={"¿Deseas eliminar este Gasto?"}
                    modal={isDelete}
                    onOk={onDelet}
                    toggle={() => { setIsdeleted(!isDelete) }}
                />
                : null}
        </td>
        {showImage ?
            <ModalMat
                open={showImage}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>

                    <IconButton
                        style={{ float: 'right' }}
                        onClick={() => {
                            setShowImage(false);
                        }}>

                        <CloseIcon />
                    </IconButton>

                    <iframe id="pdfV" width="1000" height="700" src={process.env.REACT_APP_PUBLIC_URL + 'gastos/' + data.data.original.id_gasto + '/' + imageShow + "/" + sessionStorage.getItem('token')} >
                    </iframe>
                </div>
            </ModalMat>
            : null}
    </Fragment>)
}

export default ReactTableActionsExpenses;